module.exports = __webpack_public_path__ + "img/Oniad-logo-1tinta-claro.4ae0ddfa.png";